export default __webpack_public_path__ + "static/media/prospect.837be763.png";